import React, { useState } from 'react';
import { Breadcrumb, Button, Col, Form, InputGroup, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { PlusIcon, SearchIcon } from '../../../components/ui/icons';
import { routes } from '../../../common/constants';
import CreateCap from './createCap';
import ListCap from './listCap';
import useListCap from './listCap/useListCap';
import useCapTable from './useCapTable';
import { ICapEndpointRow } from './capTypes';
import '../das/das.scss';
import './cap.scss';

const Cap = () => {
  const [show, setShow] = useState(false);
  const [editingEndpoint, setEditingEndpoint] = useState<ICapEndpointRow | null>(null);
  const { handleSearchSubmit, searchTerm, handleSearchChange } = useCapTable();
  const listCapState = useListCap();

  const handleShow = () => {
    if (show) {
      setEditingEndpoint(null);
    }
    setShow(!show);
  };

  const handleAdd = () => {
    setEditingEndpoint(null);
    setShow(true);
  };

  const handleEdit = (endpoint: ICapEndpointRow) => {
    setEditingEndpoint(endpoint);
    setShow(true);
  };

  return (
    <div className="integration-container">
      <div className="integration-header">
        <div className="integration-header-content">
          <div className="integration-heading">3rd Party Integration</div>
        </div>
        <Row>
          <Col sm={6}>
            <div className="integration-breadcrumb">
              <Breadcrumb>
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: `${routes.integrations}` }}>
                  3rd Party Integration
                </Breadcrumb.Item>
                <Breadcrumb.Item active>CAP / Rave Alert Configuration</Breadcrumb.Item>
              </Breadcrumb>
            </div>
          </Col>
          <Col sm={2}></Col>
          <Col sm={4}>
            {!show ? (
              <div className="dm-search-input">
                <Form onSubmit={(e) => handleSearchSubmit(e, listCapState.setGlobalFilter)}>
                  <InputGroup>
                    <Form.Control
                      placeholder="Search by Endpoint Name"
                      aria-label="Search"
                      aria-describedby="cap-search-input"
                      value={searchTerm}
                      onChange={(e) => handleSearchChange(e, listCapState.setGlobalFilter)}
                    />
                    <Button
                      id="cap-search-input"
                      onClick={(e) => handleSearchSubmit(e, listCapState.setGlobalFilter)}
                    >
                      <SearchIcon />
                    </Button>
                  </InputGroup>
                </Form>
              </div>
            ) : null}
          </Col>
        </Row>
      </div>

      {!show ? (
        <div className="integration-body">
          <Row>
            <Col sm={2} className="label">
              <h5>Endpoints</h5>
            </Col>
            <Col sm={7}></Col>
            <Col sm={3}>
              <div className="integration-config-btn">
                <Button onClick={handleAdd}>
                  <PlusIcon /> Add CAP Endpoint
                </Button>
              </div>
            </Col>
          </Row>
          <ListCap {...listCapState} handleEdit={handleEdit} />
        </div>
      ) : (
        <div className="integration_accordian">
          <CreateCap
            key={editingEndpoint?.id || 'create'}
            handleShow={handleShow}
            editEndpoint={editingEndpoint}
          />
        </div>
      )}
    </div>
  );
};

export default Cap;
